import axios from 'axios';

export default axios.create({
    baseURL: process.env.REACT_APP_URL_BACKEND || `http://api-desktop.seeding.live/api/v1`,
    headers: {
        'Content-Type': 'application/json',
    },
});
